(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'API_URL'];

    function AuthServerProvider($http, $localStorage, API_URL) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken() {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken() {
            var token = this.getToken();
            return !!token;
        }

        function login(credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.login) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post(API_URL + 'api/login', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                timeout: 0
            }).success(function(response) {
                return response;
            });
        }

        function logout() {
            // logout from the server
            return $http.post(API_URL + 'api/logout').success(function(response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get(API_URL + 'api/welcome'); //Change to 'api/account' if needed
                return response;
            });
        }
    }
})();
